/**
 * ID du titre de la carte.
 */
export const ID_CARD_TITLE = 'bnum-card-title';

/**
 * ID de l'élément affiché quand il n'y a pas d'événements.
 */
export const ID_CARD_ITEM_NO_ELEMENTS = 'no-elements';

/**
 * Nom de l'événement déclenché lorsque les éléments changent.
 */
export const CHANGE_EVENT = 'bnum-card-agenda:change';

/**
 * Clé de données pour l'URL.
 */
export const DATA_URL = 'url';

/**
 * Attribut pour l'URL des données.
 */
export const ATTRIBUTE_DATA_URL = `data-${DATA_URL}`;

/**
 * Attribut pour l'état de chargement.
 */
export const ATTRIBUTE_LOADING = 'loading';
